<template>
  <div class="yxtbiz-kng-comment-audit-content standard-size-14" v-loading="loading">
    <div class="standard-size-16 yxt-weight-5">{{$t('pc_biz_kng_lbl_commentdetail'/**评论详情 */)}}</div>
    <div class="yxtbiz-kng-comment-audit-content__line mt24  standard-size-14">
      <span class="color-gray-7 flex-shrink-0" :class="isEnglish?'w98':'w68'">{{$t('pc_biz_kng_lbl_commentcontent'/**评论内容 */)}}</span>
      <span class="yxtbiz-kng-comment-audit-content__text ml12" v-html="info.content"></span>
    </div>
    <div class="yxtbiz-kng-comment-audit-content__line mt24 standard-size-14">
      <span class="color-gray-7 flex-shrink-0" :class="isEnglish?'w98':'w68'">{{$t('pc_biz_kng_lbl_commentname'/** 课程名称*/)}}</span>
      <yxt-tooltip class="ml12" :content="info.targetName" open-filter>
        <div class="ellipsis-1 color-primary-6 ml12">
          <span class="hand" @click="preview">{{info.targetName}}</span>
        </div>
      </yxt-tooltip>
    </div>

  </div>
</template>

<script>
import { getCommentInfo } from '../service';
import { getKngType } from '../../kng-audit-content/service';
import { FILE_TYPE_TO_ROUTE_PATH } from '../../kng-audit-content/enum';
import commonUtil from 'yxt-biz-pc/packages/common-util';
export default {
  name: 'YxtbizKngCommentAuditContent',
  name_zh: '课程评论审核内容',
  props: {
    id: {
      type: String,
      required: true,
      desc: '知识id',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      info: {},
      loading: false
    };
  },
  computed: {
    isEnglish() {
      return commonUtil.getLanguage() === 'en';
    }
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        this.getInfo();
      }
    }
  },
  methods: {
    preview() {
      getKngType(this.info.targetId)
        .then(({ fileType }) => {
          const id = fileType !== 'course' ? this.info.targetId : '';
          const courseId = fileType === 'course' ? this.info.targetId : '';
          const url = `/kng/#/${FILE_TYPE_TO_ROUTE_PATH[fileType]}/preview/detail?id=${id}&courseId=${courseId}&previewType=2`;
          window.open(url);
        })
        .catch(e => {
          if (e && e.error && e.error.message) {
            this.$message.error(e.error.message);
          }
        });
    },
    getInfo() {
      this.loading = true;
      getCommentInfo({commentIds: [this.id], orgId: window.localStorage.orgId})
        .then(({ datas }) => {
          this.info = datas && datas.length ? datas[0] : {};
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>
